import { z } from 'zod';

export const agentConfigSchema = z.object({
  agent: z
    .object({
      name: z.string({ message: 'Name is required' }).min(1, { message: 'Name is required' }),
      agent_type: z.string({ message: 'Agent type is required' }).min(1, { message: 'Agent type is required' }),
      languages: z.union([
        z.string({ message: 'Language is required' }).min(1, { message: 'Language is required' }),
        z.array(z.string()).min(1, { message: 'At least one language is required' })
      ]),
      tone: z.string({ message: 'Tone is required' }).min(1, { message: 'Tone is required' }),
      voice_id: z.string({ message: 'Voice is required' }).min(1, { message: 'Voice is required' }),
      voice_type: z.string().optional(),
      enable_welcome_message: z.boolean().optional(),
      welcome_message: z.any().optional(),
      enable_call_recording: z.boolean().optional()
    })
    .refine(
      (data) => {
        if (data.enable_welcome_message === true) {
          return data.welcome_message && data.welcome_message.trim().length > 0;
        }
        return true;
      },
      {
        message: 'Welcome message is required when welcome message is enabled',
        path: ['welcome_message']
      }
    )
});

export const advanceSettingsSchema = z.object({
  speech_speed: z.any().optional(),
  ambient_sound_volume: z.any().optional(),
  thinking_sound_volume: z.any().optional(),
  booster_keywords: z.any().optional(),
  ambient_sound: z.any().optional(),
  thinking_sound: z.any().optional(),
  silence_message_delay: z
    .union([
      z.string({ message: 'Silence message delay is required' }).nonempty({
        message: 'Silence message delay is required'
      }),
      z.number({ message: 'Silence message delay is required' })
    ])
    .refine((val) => !isNaN(Number(val)), {
      message: 'Silence message delay must be a valid number'
    }),
  silence_end_call: z.any().optional(),
  use_delay_fillers: z.any().optional(),
  max_reminder_times: z.any().optional(),
  max_call_duration: z.any().optional(),
  performance_mode: z.enum(['accuracy_optimized', 'speed_optimized']).optional(),
  summarize_before_warm_transfer: z.boolean().optional(),
  transcribe_filler_words: z.any().optional()
});
